module.exports = __webpack_public_path__ + "img/03_no.bea1ef1d.svg";